export const USER_CREATE = 'userCreate'
export const USER_EDIT = 'userEdit'
export const USER_DELETE = 'userDelete'
export const USER_GET = 'userGet'
export const USERS_GET = 'usersGet'
export const UPDATE_USER = 'updateUser'
export const PERMISSIONS_GET = 'permissionsGet'
export const USER_SEARCH = 'userSearch'
export const USER_ACTIVE = 'userActive'
export const USER_INACTIVE = 'userInactive'